import React from "react";
import { withRouter } from "react-router-dom";
import cogoToast from "cogo-toast";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for debugging
    // console.error("ErrorBoundary caught an error:", error, errorInfo);
    
    // // Show toast message first
    // cogoToast.error("An error occurred. Please try again.", {
    //   hideAfter: 5,
    //   position: "top-right",
    // });
    
    // DISABLED: Redirect to dashboard (avoid redirect loops)
    // Uncomment below to re-enable redirect on errors
    /*
    try {
      const currentPath = window.location.pathname;
      if (currentPath !== '/dashboard' && currentPath !== '/login' && !currentPath.startsWith('/vendor/')) {
        if (this.props.history) {
          this.props.history.push("/dashboard");
        } else {
          // Fallback if history is not available
          window.location.href = "/dashboard";
        }
      }
    } catch (redirectError) {
      // If redirect fails, use window.location as fallback
      const currentPath = window.location.pathname;
      if (currentPath !== '/dashboard' && currentPath !== '/login') {
        window.location.href = "/dashboard";
      }
    }
    */
    
    // Reset error state after a delay to allow retry
    // setTimeout(() => {
    //   this.setState({ hasError: false, error: null });
    // }, 100);
  }

  render() {
    if (this.state.hasError) {
      // Show error message instead of redirecting
      return (
        <div style={{ padding: '20px', margin: '20px', border: '2px solid red', backgroundColor: '#ffe6e6' }}>
          <h2>Error Boundary Caught an Error</h2>
          <p><strong>Error:</strong> {this.state.error?.toString()}</p>
          <details>
            <summary>Error Details</summary>
            <pre>{this.state.error?.stack}</pre>
          </details>
          <button 
            onClick={() => window.location.reload()} 
            style={{ padding: '10px 20px', marginTop: '10px', cursor: 'pointer' }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);

